import{a as m}from"./chunk-3F27QTJW.js";import{a as e}from"./chunk-6AAYEFVP.js";import{n as o,o as r}from"./chunk-5NG2JD2X.js";var i=new o({locale:[m,e,r]});export{i as a};
